import { jsx as _jsx } from "react/jsx-runtime";
var UpTrend = function UpTrend(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 18 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: 0.66667 * size,
    viewBox: "0 0 18 12",
    fill: "none",
    className: className,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.992.963c-.002-.072-.023-.14-.042-.209-.015-.058-.022-.117-.047-.17-.023-.052-.062-.094-.096-.142-.042-.061-.08-.122-.134-.172-.009-.009-.013-.021-.023-.029-.036-.031-.08-.042-.119-.067-.06-.039-.119-.079-.187-.105-.067-.024-.133-.03-.202-.04C17.094.022 17.052 0 17 0h-5a1 1 0 100 2h2.826L10.79 6.708 6.514 4.143a.997.997 0 00-1.283.217l-5 6a1 1 0 001.537 1.28L6.22 6.298l4.265 2.56a1 1 0 001.274-.207L16 3.703V6a1 1 0 102 0V1c0-.013-.007-.024-.008-.037z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default UpTrend;